/*
* relevant references:
* https://github.com/jitsi/lib-jitsi-meet/blob/4e5397685287d8d87f29591546f7c902eac22bf0/JitsiConference.js#L1406
* */

window.kealthlive = {

    api: null,

    doConnection: function(apiUrl, room, domain, userInfo, elem, params){


        $.getScript(apiUrl, function( data, textStatus, jqxhr ) {
        var options = {
            roomName: room,
            width: params.width,
            height: params.height,
            interfaceConfigOverwrite: {
                filmStripOnly: false,
                TOOLBAR_BUTTONS: ['microphone', 'camera', 'fullscreen', 'hangup', 'chat', 'videoquality']
                //DISPLAY_WELCOME_FOOTER: false,
                //CONNECTION_INDICATOR_DISABLED: true,
                //DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
                //SHOW_JITSI_WATERMARK: false,

            },
            parentNode: document.querySelector(elem),
            userInfo: {
                displayName: userInfo.displayName
            }
        }

        kealthlive.api = new JitsiMeetExternalAPI(domain, options);
        kealthlive.api.executeCommand('subject', ' ');
        kealthlive.showVideoConferencePanel();
        kealthlive.initializeEvents();
        $('#videoconference-ct .call_btn').prop('disabled',true);

        kealthlive.api.addEventListeners({
                readyToClose: kealthlive.close,
            });

        });

    },

    close: function () {
        kealthlive.hideVideoConferencePanel();
        kealthlive.api.dispose();
    },

    showVideoConferencePanel: function () {
        $('#videoconference-ct').fadeIn("slow");
        $('#contextual-buttons #call').prop("disabled", true);

        $('#videoconference-ct').data({
            'originalBottom': $('#videoconference-ct').css('bottom'),
            'origionalRight': $('#videoconference-ct').css('right')
        });

    },

    hideVideoConferencePanel: function () {
        $('#videoconference-ct').fadeOut("slow");
        $('#contextual-buttons #call').prop("disabled", false);

        setTimeout(function () {
        }, 500)
        $('#videoconference-ct').css({width: '350px', height: '325px'});
        $('#videoconference-ct').css({bottom: $('#videoconference-ct').parent().offset().bottom + 105,
            right: $('#videoconference-ct').parent().offset().right + 105});
    },

    hangup: function () {
        this.api.executeCommand('hangup');
    },

    toogleAudio: function(){
        this.api.executeCommand('toggleAudio');
    },

    toogleVideo: function(){
        this.api.executeCommand('toggleVideo');
    },

    toogleChat: function(){
        this.api.executeCommand('toggleChat');
    },

    outOfRoomCheckParticipantJoined: function (elem, params){

        $.getJSON('/kealthlive/jitsi/check_participant_joined', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                debug.log('success', data);

                if (data.success) {
                    if (data.data.status == 'online'){
                        $(elem).removeClass('kealthlive_offline');
                        $(elem).addClass('kealthlive_online');
                    }

                } else {
                    $(elem).removeClass('kealthlive_online');
                    $(elem).addClass('kealthlive_offline');
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                $(elem).removeClass('kealthlive_online');
                $(elem).addClass('kealthlive_offline');

                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    initializeEvents: function () {

        $("#videoconference-ct .hangup_btn").click(function () {

            kealthlive.hangup();
            kealthlive.close();
            Hades.showBalloonMessage('Chamada terminada', 'alert-success', 2000);

        })

        $("#videoconference-ct button#mic_btn").click(function (e) {

            $(this).prop('disabled', true);

        });

        $("#videoconference-ct button#mic-btn").click(function (e) {

            var isMuted = ($(this).hasClass("mic_btn_mute"))

            if (isMuted){
                $(this).removeClass("mic_btn_mute");
                $(this).addClass("mic_btn");
                Hades.showBalloonMessage('Microfone ligado', 'alert-info', 1000);

            }
            else {
                $(this).removeClass("mic_btn");
                $(this).addClass("mic_btn_mute");
                Hades.showBalloonMessage('Microfone desligado', 'alert-info', 1000);

            }
            kealthlive.toogleAudio();

        });

        $("#videoconference-ct button#cam-btn").click(function (e) {

            var isMuted = ($(this).hasClass("cam_btn_mute"))

            if (isMuted){
                $(this).removeClass("cam_btn_mute");
                $(this).addClass("cam_btn");
                Hades.showBalloonMessage('Camera ligada', 'alert-info', 1000);

            }
            else {
                $(this).removeClass("cam_btn");
                $(this).addClass("cam_btn_mute");
                Hades.showBalloonMessage('Camera desligada', 'alert-info', 1000);

            }
            kealthlive.toogleVideo();

        });



    }

};

